/** Pure helpers for the Track Finder tab (RC Car Action's review queue). */

/** Queue target is 7 days; open items 7 or more whole days old are overdue (server: created_at < now - 7 days). */
export const OVERDUE_DAYS = 7

export type QueueKind = 'report' | 'suggestion' | 'possible_duplicate'
export type QueueAction = 'approve' | 'verify' | 'close' | 'merge' | 'dismiss'

export function queueBadge(item: { age_days: number }): { label: string; tone: 'overdue' | 'normal' } {
  const n = item.age_days
  const age = n <= 0 ? 'Today' : n === 1 ? '1 day' : `${n} days`
  return n >= OVERDUE_DAYS ? { label: `Overdue · ${age}`, tone: 'overdue' } : { label: age, tone: 'normal' }
}

/** The buttons that apply to a kind. Writers get none (the server refuses them anyway). */
export function actionsFor(kind: string, isEditor: boolean, hasTrack = true): QueueAction[] {
  if (!isEditor) return []
  if (kind === 'suggestion') return ['approve', 'dismiss']
  if (kind === 'possible_duplicate') return ['merge', 'dismiss']
  return hasTrack ? ['verify', 'close', 'dismiss'] : ['dismiss']
}

/** Reader-supplied websites become links only when they are http(s). */
export function safeWebsite(v: unknown): string | null {
  return typeof v === 'string' && /^https?:\/\//i.test(v.trim()) ? v.trim() : null
}

export const KIND_LABEL: Record<string, string> = {
  report: 'Reader report',
  suggestion: 'Suggested track',
  possible_duplicate: 'Possible duplicate',
  new_from_source: 'New from source',
  recheck: 'Check if still open',
}

/** Where the nav badge gets the open/overdue count: editors and writers with RC Car Action access
 *  read the queue itself (the dashboard is closed to them); admins and viewers use the dashboard totals. */
export function queueCountSource(role: string | undefined, sections: { slug: string }[] | undefined): 'dashboard' | 'queue' | 'none' {
  if (!role || role === 'operator') return 'none'
  if (role === 'editor' || role === 'writer') return (sections ?? []).some((s) => s.slug === 'rc_car_action') ? 'queue' : 'none'
  return 'dashboard'
}
